import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    ISSUES_TYPES_FETCH_ITEM,
    ISSUES_TYPES_ADD_ITEM,
    ISSUES_TYPES_DELETE_ITEM
} from './actions_def';
import {
    getIssuesTypeItemSuccess,
    getIssuesTypeItemError,
    addIssuesTypeItemSuccess,
    addIssuesTypeItemError,
    deleteIssuesTypeItemSuccess,
    deleteIssuesTypeItemError


} from './actions';


const apiUrl = servicePath;


const getIssuesTypeItemRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/issuetypes/' + payload.typeId, { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        type: item.rfc_type,
                        typeColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesTypeItem() {
    try {
        const response = yield call(getIssuesTypeItemRequest);
        yield put(getIssuesTypeItemSuccess(response));
    } catch (error) {
        yield put(getIssuesTypeItemError(error));
    }
}


const addIssuesTypeItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    console.log(item);
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _type = 1;
        switch (item.type) {
            case "PENDING": _type = 1; break;
            default: _type = 1;
        };

        let _sendingPayload = {
            Name: item.name,
            ProjectId: item.projectId,
            Notes: item.description ? item.description : ' ',
            DueDate: item.due_date ? item.due_date : new Date(),
            ReleaseDate: item.due_date ? item.due_date : new Date(),
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/issuetypes/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.type !== 200 && response.data.type !== 201) {
                        fail(response.data);
                    }
                    else {
                        success(response.data);
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addIssuesTypeItem({ payload }) {
    // // console.log(payload);;
    try {
        const response = yield call(addIssuesTypeItemRequest, payload);
        console.log('Response :', response, response.type === "fail")
        if (response.type !== "fail") {
            yield put(addIssuesTypeItemSuccess(response));
        }
        else {
            yield put(addIssuesTypeItemError(response));
        }
    } catch (error) {
        yield put(addIssuesTypeItemError(error));
    }
}


const deleteIssuesTypeRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/issuetypes/' + item.typeId,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.type === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.type === "success" || response.data.type === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.type);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesTypeItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteIssuesTypeRequest, payload);
        console.log('Response :', response, response.type === "fail")
        if (response.type !== "fail") {
            yield put(deleteIssuesTypeItemSuccess(response));
        }
        else {
            yield put(deleteIssuesTypeItemError(response));
        }
    } catch (error) {
        yield put(addIssuesTypeItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(ISSUES_TYPES_FETCH_ITEM, getIssuesTypeItem);
}

export function* watchAddItem() {
    yield takeEvery(ISSUES_TYPES_ADD_ITEM, addIssuesTypeItem);
}
export function* watchDeleteItem() {
    yield takeEvery(ISSUES_TYPES_DELETE_ITEM, deleteIssuesTypeItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
